import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import { FloatingTooltip } from '../../Floating'
import { IconNG } from '../../Icon'
import { ButtonSelect, ButtonTextSelectControl } from '../../Select'
import { UploadImageModal } from '../../UploadImage'
import { EntityProfileHeaderStaticAvatar } from '../EntityProfileHeaderStaticAvatar'

import {
  ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_DROPDOWN_CONFIG,
  QA_NAME_ENTITY_PROFILE_HEADER_EDITABLE_AVATAR,
} from './EntityProfileHeaderEditableAvatar.constants'
import { useEntityProfileHeaderEditableAvatar } from './EntityProfileHeaderEditableAvatar.hooks'
import {
  getEntityProfileHeaderEditableAvatarMenuOptions,
  isEntityProfileHeaderEditableAvatarMenuActionEdit,
} from './EntityProfileHeaderEditableAvatar.utils'

import * as styles from './EntityProfileHeaderEditableAvatar.module.css'

import CameraIcon from '../../../icons/activities/camera.svg'

function EntityProfileHeaderEditableAvatar({
  avatarDocumentId = null,
  cropShape,
  qaName = QA_NAME_ENTITY_PROFILE_HEADER_EDITABLE_AVATAR,
  setModal,
  onCloseModal,
  onConfirmDelete,
  onEntityReload,
  onSave,
  onUpdateEntity,
  ...avatarProps
}) {
  const { t } = useTranslation()

  const {
    fileInputProps,
    handleDelete,
    handleOpen,
    hasAvatar,
    isOpen,
    modalProps,
  } = useEntityProfileHeaderEditableAvatar({
    avatarDocumentId,
    avatarSrc: avatarProps.src ?? null,
    cropShape,
    setModal,
    onCloseModal,
    onConfirmDelete,
    onEntityReload,
    onSave,
    onUpdateEntity,
  })

  function handleSelectMenuOption({ value }) {
    if (isEntityProfileHeaderEditableAvatarMenuActionEdit(value)) {
      handleOpen()
    } else {
      handleDelete()
    }
  }

  return (
    <>
      <FloatingTooltip
        content={t(
          hasAvatar ? 'Profile.EditBtnKey' : 'UploadImage.AddImageTitleKey'
        )}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        <span className={styles.EntityProfileHeaderEditableAvatar}>
          {hasAvatar ? (
            <ButtonSelect
              Control={ButtonTextSelectControl}
              className={styles.select}
              controlProps={{
                Button: EntityProfileHeaderStaticAvatar,
                buttonProps: avatarProps,
                className: styles.avatarButton,
              }}
              dropdownFloatingConfig={
                ENTITY_PROFILE_HEADER_EDITABLE_AVATAR_DROPDOWN_CONFIG
              }
              filter={null}
              listProps={{
                headerProps: { Search: null },
                itemProps: {
                  contentProps: {
                    infoProps: {
                      contentTextProps: { textProps: { isSecondary: true } },
                    },
                  },
                },
              }}
              options={getEntityProfileHeaderEditableAvatarMenuOptions(t)}
              qaName={qaName}
              onSelectItem={handleSelectMenuOption}
            />
          ) : (
            <EntityProfileHeaderStaticAvatar
              {...avatarProps}
              Container='button'
              className={styles.avatar}
              containerProps={{
                type: 'button',
                onClick: handleOpen,
                ...getQaSelector({ value: qaName }),
              }}
            >
              <span className={styles.addPhotoHoverLayer}>
                <IconNG Icon={CameraIcon} color='var(--color-white)' />
              </span>
            </EntityProfileHeaderStaticAvatar>
          )}
        </span>
      </FloatingTooltip>

      <input {...fileInputProps} />

      {isOpen ? <UploadImageModal {...modalProps} /> : null}
    </>
  )
}

export default EntityProfileHeaderEditableAvatar
